/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-key */
import { useEffect, useMemo, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  usePagination,
} from "react-table";
import { COLUMNS } from "../../components/table/FilteringTable/Columns";
import { GlobalFilter } from "../../components/table/FilteringTable/GlobalFilter";
import "../table/FilteringTable/filtering.css";
import { Link } from "react-router-dom";
import axios from "axios";

// Default column filter
const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)} // Set undefined to remove the filter entirely
      placeholder={`Search...`}
      className="form-control"
    />
  );
};

export const Restaurants = () => {
  const columns = useMemo(() => COLUMNS, []);
  const [restaurants, setRestaurants] = useState([]);

  const fetchRestaurants = async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_REACT_APP_BACKEND_URL}/restau`
      );
      const data = response?.data?.data || [];
      console.log("Fetched data:", data); // Ajouté pour déboguer
      setRestaurants(
        data.filter((item) => item && Object.keys(item).length > 0)
      ); // Filtre les objets vides
    } catch (error) {
      console.error("Error fetching restaurants:", error);
    }
  };

  useEffect(() => {
    fetchRestaurants();
  }, []);

  const tableInstance = useTable(
    {
      columns,
      data: restaurants,
      initialState: { pageIndex: 0 },
      defaultColumn: { Filter: DefaultColumnFilter }, // Add default column filter
    },
    useFilters, // Enables per-column filtering
    useGlobalFilter, // Enables global filtering
    usePagination // Enables pagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    setGlobalFilter,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  return (
    <>
      <PageTitle activeMenu="Data" motherMenu="Restaurants" />
      <div className="card">
        <div className="row">
          <div className="col-lg-3">
            <div className="card-header">
              <h4 className="card-title">Brands</h4>
            </div>
          </div>
          <div className="col-lg-9 justify-content-end d-flex">
            <Link
              to={"/create-brand"}
              className="mx-2 mt-2 w-25 btn btn-primary btn-block"
            >
              Add New Brand
            </Link>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            {/* Global Filter */}
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              className="table filtering-table table-responsive-lg"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* Render column-specific filter */}
                        <div>
                          {column.canFilter ? column.render("Filter") : null}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.length > 0 ? (
                  page.map((row) => {
                    prepareRow(row);
                    if (!row.original || Object.keys(row.original).length === 0)
                      return null; // Ignore les lignes vides
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td style={{ width: "13%" }} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6">No restaurants available</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center">
              <span>
                Page{" "}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>
              </span>

              <span className="table-index">
                Go to page:{" "}
                <input
                  type="number"
                  className="ms-2"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const pageNumber = e.target.value
                      ? Math.max(
                          0,
                          Math.min(Number(e.target.value) - 1, pageCount - 1)
                        )
                      : 0;
                    gotoPage(pageNumber);
                  }}
                />
              </span>
            </div>

            <div className="text-center mt-3">
              <button
                className="btn btn-primary me-2"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>
              <button
                className="btn btn-primary me-2"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Previous
              </button>
              <button
                className="btn btn-primary me-2"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next
              </button>
              <button
                className="btn btn-primary"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Restaurants;
